import { gql } from "@apollo/client"

export const SUBSCRIPTION_NOTICATION_SIDENAV = gql`
subscription OnSubNoticationSideNav($shopId: ID!) {
    onSubNoticationSideNav(shopId: $shopId) {
      id
    }
  }
`; 